module.exports = __webpack_public_path__ + "static/media/CommonPaymentSuccess.6013cda9.svg";